var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"custom-tooltip",attrs:{"data-tooltip":_vm.text,"data-flow":_vm.flow}})
}
var staticRenderFns = []

export { render, staticRenderFns }